import React,{ useState,useEffect } from 'react';
import ReactDOM from 'react-dom';
import '../App.css';

export default function FooterControl(props) {

   const [value,setValue] = React.useState(30);
   const [prevDeltaScene,setPrevDeltaScene] = React.useState(0);
   const [zoombarValue,setZoombarValue] = React.useState(0);

   const handleChange = (event,newValue) => {
      setValue(newValue);
   };

   const handleZoomChange = (e,newValue) => {

      if (window.zoonOutCamStatus == true && window.zoomOutCam != "") {
         window.zoonOutCamStatus = false;
   
         // this code is used to hide pop on mouse down
         var allPopup = document.querySelector('.popup.active');
         if (allPopup != null) {
            allPopup.classList.remove('active');
         }
         if (window.zoomOutPort == "quickAccessPorts") {

            window.handleZoomoutCam(window.zoomOutCamStateBtns,window.zoomOutCam,window.zoomOutCamRotationCenter)
   
         } else if (window.zoomOutPort == "ports") {
            //portFirstClick = false;
            window.handleZoomoutCam(window.zoomOutCamStateBtns,window.zoomOutCam,window.zoomOutCamRotationCenter)
                  
         } else if (window.zoomOutPort == "back") {
            
            // if(window.mob || window.isipad){
            //    window.scene._nav._navMinDolly = 110;
            //    window.scene._nav._navMaxDolly = 400;
            // }
            // else{
            //    window.scene._nav._navMinDolly = 21;
            //    window.scene._nav._navMaxDolly = 70;
            // }
            window.handleZoomoutCam(window.zoomOutCamStateBtns,window.zoomOutCam,window.zoomOutCamRotationCenter)
            
         }
      

   }
      if (e) {
         window.scene._nav.NavChangeDolly(undefined,e.target.value / 100);
      } else {
         window.scene._nav.NavChangeDolly(undefined,newValue / 100);
         document.getElementById("sliderRange").value = newValue;
      }
      if (window.selectedButton != 'accordion_interiorFeatur') {
         window.selectedButton = '';
      }
      window.hidePopUp();
      window.hideDimension();
      window.clickedCheck.menuClicked = '';
      window.hotspot = '';
      var sliderValues = document.getElementById('sliderRange').value * 100;

      if (sliderValues !== null) {
         document.getElementById('sliderRange').setAttribute('aria-label','');
         setTimeout(function () {
            document.getElementById('sliderRange').setAttribute('aria-label','%');
         },400)
      }
   };

   //only for mob
   const [camData,setCamData] = useState("");
   var animationSwitch = window.Animation;
   var animTime = 1;

   const onZoomIn = (e) => {
      // var center = [0, 0, 0];
      // window.scene._nav.SetRotationCenter(center);
      window.clickedCheck.menuClicked = '';
   if (window.zoonOutCamStatus == true && window.zoomOutCam != "") {
      window.zoonOutCamStatus = false;

      // this code is used to hide pop on mouse down
      var allPopup = document.querySelector('.popup.active');
      if (allPopup != null) {
         allPopup.classList.remove('active');
      }
      if (window.zoomOutPort == "quickAccessPorts") {
         window.handleZoomoutCam(window.zoomOutCamStateBtns,window.zoomOutCam,window.zoomOutCamRotationCenter)
      } else if (window.zoomOutPort == "ports") {
         window.handleZoomoutCam(window.zoomOutCamStateBtns,window.zoomOutCam,window.zoomOutCamRotationCenter)    
      } else if (window.zoomOutPort == "back") {
         window.handleZoomoutCam(window.zoomOutCamStateBtns,window.zoomOutCam,window.zoomOutCamRotationCenter)
      }
   

}

      var slider = document.getElementById("sliderRange");

      if (slider !== null) {
         document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor();
         setTimeout(function () { document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor(); },1000);
      }

      if (window.scene._nav.getZoomFactor() > 0)
         handleZoomChange(null,-1 + (parseFloat(document.getElementById("sliderRange").value)))
   }

   const onZoomOut = (e) => {
      // var center = [0, 0, 0];
      // window.scene._nav.SetRotationCenter(center);
      window.clickedCheck.menuClicked = '';
   if (window.zoonOutCamStatus == true && window.zoomOutCam != "") {
      window.zoonOutCamStatus = false;

      // this code is used to hide pop on mouse down
      var allPopup = document.querySelector('.popup.active');
      if (allPopup != null) {
         allPopup.classList.remove('active');
      }
      if (window.zoomOutPort == "quickAccessPorts") {
         window.handleZoomoutCam(window.zoomOutCamStateBtns,window.zoomOutCam,window.zoomOutCamRotationCenter)
      } else if (window.zoomOutPort == "ports") {
         window.handleZoomoutCam(window.zoomOutCamStateBtns,window.zoomOutCam,window.zoomOutCamRotationCenter)    
      } else if (window.zoomOutPort == "back") {
         window.handleZoomoutCam(window.zoomOutCamStateBtns,window.zoomOutCam,window.zoomOutCamRotationCenter)
      }
   

}

      var slider = document.getElementById("sliderRange");

      if (slider !== null) {
         document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor();
         setTimeout(function () { document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor(); },1000);
      }

      if (window.scene._nav.getZoomFactor() < 100)
         handleZoomChange(null,1 + (parseFloat(document.getElementById("sliderRange").value)))
   }
   const onLeft = () => {
      // var center = [0, 0, 0];
      // window.scene._nav.SetRotationCenter(center);
      window.scene._nav.NavRotation([0,0],[12,0]);
      window.hotspot = '';
      window.clickedCheck.menuClicked = '';
      window.hidePopUp();
      window.hideDimension();
      if (window.zoonOutCamStatus == true && window.zoomOutCam != "") {
         window.zoonOutCamStatus = false;
   
         // this code is used to hide pop on mouse down
         var allPopup = document.querySelector('.popup.active');
         if (allPopup != null) {
            allPopup.classList.remove('active');
         }
         if (window.zoomOutPort == "quickAccessPorts") {

            window.handleZoomoutCam(window.zoomOutCamStateBtns,window.zoomOutCam,window.zoomOutCamRotationCenter)
   
         } else if (window.zoomOutPort == "ports") {
            //portFirstClick = false;
            window.handleZoomoutCam(window.zoomOutCamStateBtns,window.zoomOutCam,window.zoomOutCamRotationCenter)
                  
         } else if (window.zoomOutPort == "back") {
            
            // if(window.mob || window.isipad){
            //    window.scene._nav._navMinDolly = 110;
            //    window.scene._nav._navMaxDolly = 400;
            // }
            // else{
            //    window.scene._nav._navMinDolly = 21;
            //    window.scene._nav._navMaxDolly = 70;
            // }
            window.handleZoomoutCam(window.zoomOutCamStateBtns,window.zoomOutCam,window.zoomOutCamRotationCenter)
            
         }
      

   }
      if (window.selectedButton != 'accordion_interiorFeatur') {
         window.selectedButton = '';
      }
      window.scene.clearRefine();
   }
   const onRight = () => {
      // var center = [0, 0, 0];
      // window.scene._nav.SetRotationCenter(center);
      window.scene._nav.NavRotation([0,0],[-12,0]);
      window.hotspot = '';
      window.clickedCheck.menuClicked = '';
      window.hidePopUp();
      window.hideDimension();
      if (window.zoonOutCamStatus == true && window.zoomOutCam != "") {
         window.zoonOutCamStatus = false;
   
         // this code is used to hide pop on mouse down
         var allPopup = document.querySelector('.popup.active');
         if (allPopup != null) {
            allPopup.classList.remove('active');
         }
         if (window.zoomOutPort == "quickAccessPorts") {

            window.handleZoomoutCam(window.zoomOutCamStateBtns,window.zoomOutCam,window.zoomOutCamRotationCenter)
   
         } else if (window.zoomOutPort == "ports") {
            //portFirstClick = false;
            window.handleZoomoutCam(window.zoomOutCamStateBtns,window.zoomOutCam,window.zoomOutCamRotationCenter)
                  
         } else if (window.zoomOutPort == "back") {
            
            // if(window.mob || window.isipad){
            //    window.scene._nav._navMinDolly = 110;
            //    window.scene._nav._navMaxDolly = 400;
            // }
            // else{
            //    window.scene._nav._navMinDolly = 21;
            //    window.scene._nav._navMaxDolly = 70;
            // }
            window.handleZoomoutCam(window.zoomOutCamStateBtns,window.zoomOutCam,window.zoomOutCamRotationCenter)
            
         }
      

   }
      if (window.selectedButton != 'accordion_interiorFeatur') {
         window.selectedButton = '';
      }
      window.scene.clearRefine();
   }

   let { previousView,resetView,nextView } = { ...props.data };
   /* 
      let data;
      if(props.data != undefined){
       data = {
         "previousView":props.data.previousView,
         "resetView":props.data.resetView,
         "nextView":props.data.nextView
      }
      
      // console.log('DATA', data.nextView);
      } else {
          data = {
            "previousView":"",
            "resetView":"",
            "nextView":""
         }
      } */

   return (
      <React.Fragment>
         {ReactDOM.createPortal(
            <div id='footerControls' className="footerControlsDesk">
               <div className="threebtns">
                  <div className="zoombarandRotateContainer">

                     <div className='topbtns'  >
                        <button className='navBtn footerBtn floatleft' aria-label="Rotate" id="rLeft" tabIndex="-1" onClick={onLeft} title="left">
                           <img alt="Rotate left" src="./images/diagonalLeftArrow.svg" />
                        </button>
                        <button className='navBtn footerBtn' aria-label="Rotate" id="rRight" tabIndex="-1" onClick={onRight} title="right">
                           <img alt="Rotate right" src="./images/diagonalRightArrow.svg" />
                        </button>
                     </div>

                     <div id="zoomSliderContainer " className='zoombar'>
                        <img style={{ height: '100%' }} alt="zoombar" src="./images/ZOOMBAR.svg" />

                        <button tabIndex="-1" className='navBtn MuiButtonBase-root MuiButton-root MuiButton-text' style={{ color: "#0076CE" }} type="button" aria-label="Clickable Zoom Out" role="button" id="zoomIn" onClick={onZoomIn}> </button>
                        <div id="zoomSlider" aria-hidden="true">
                           <div className="rangeslider" aria-hidden="true">
                              <label> <input tabIndex="-1" aria-hidden="true" type="range" min="0" max="100" step="1" className="myslider" onChange={handleZoomChange} id="sliderRange" />
                              </label>
                           </div>
                        </div>
                        <button className='navBtn MuiButtonBase-root MuiButton-root MuiButton-text' tabIndex="-1" style={{ color: "#0076CE" }} type="button" id="zoomOut" role="button" aria-label="Clickable Zoom In" onClick={onZoomOut}></button>
                     </div>
                  </div>
                  <div className='clearBoth' >
                     <button tabIndex="-1" className='navBtn threeButtons' aria-label="Previous view" id="previousView" variant="outlined" color="primary" onClick={props.onPrevious} >
                        <img alt="Previous view" id="previousViewImg" src="./images/leftArrow.svg" />{previousView !== undefined ? previousView : 'Previous View'}
                     </button>
                     <button tabIndex="-1" className='navBtn threeButtons' variant="outlined" id="resetView" color="primary" onClick={props.onReset} >
                        {resetView !== undefined ? resetView : 'Reset View'}
                     </button>
                     <button tabIndex="-1" className='navBtn threeButtons' aria-label="Next view" id="nextView" variant="outlined" color="primary" onClick={props.onNext} expanded={props.expanded} >
                        {nextView !== undefined ? nextView : 'Next View'}
                        <img alt="Next view" id="nextViewImg" src="./images/rightArrow.svg" />
                     </button>
                  </div>
               </div>
            </div>,document.getElementById('footerControlDesk')
         )}
      </React.Fragment>

   );
}
